import { LinearProgress, withStyles } from '@material-ui/core';
import * as styles from './styles';

import { colors } from '../styles';

export const StyledProgressBar = withStyles({
  root: {
    width: '100%',
    height: '5px',
    backgroundColor: colors.gray.light,
    borderRadius: '2.5px',
  },
  bar: {
    backgroundColor: colors.primary.default,
    borderRadius: '2.5px',
  },
})(LinearProgress);

export interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  label?: string;
}

const getStepPercentage = (step: number, steps: number) => (step * 100) / steps;

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const ProgressBar = ({ currentStep, totalSteps, label }: ProgressBarProps) => (
  <div className={styles.progressBar}>
    <StyledProgressBar variant='determinate' value={getStepPercentage(currentStep, totalSteps)} />
    {label && <span>{label}</span>}
  </div>
);
